import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  allTasks: [],          // stores the complete task list
  filteredTasks: [],     // stores the filtered tasks based on date filters
  selectedTasks: [],     // stores selected task identifiers
  loading: false,
  error: null,
};

const taskSlice = createSlice({
  name: "task",
  initialState,
  reducers: {
    setAllTasks: (state, action) => {
      state.allTasks = action.payload;
    },
    setFilteredTasks: (state, action) => {
      state.filteredTasks = action.payload;
    },
    setSelectedTasks: (state, action) => {
      state.selectedTasks = action.payload;
    },
    resetTaskState: (state) => {
      state.allTasks = [];
      state.filteredTasks = [];
      state.selectedTasks = [];
    },
  },
});

export const {
  setAllTasks,
  setFilteredTasks,
  setSelectedTasks,
  resetTaskState,
} = taskSlice.actions;

export default taskSlice.reducer;

                {/* FILE UPLOADS */}
                {/* <Col md="4" className="mb-1">
                  <Label>Profile Picture (JPG)</Label>
                  <Input
                    type="file"
                    accept=".jpg,.jpeg"
                    onChange={(e) => setProfilePic(e.target.files[0])}
                  />
                  {profilePic && (
                    <img
                      src={URL.createObjectURL(profilePic)}
                      alt="Profile Preview"
                      className="mt-1"
                      width="100"
                    />
                  )}
                </Col>

                <Col md="4" className="mb-1">
                  <Label>Aadhaar Card</Label>
                  <Input
                    type="file"
                    onChange={(e) => setAadharCard(e.target.files[0])}
                  />
                </Col>

                <Col md="4" className="mb-1">
                  <Label>PAN Card</Label>
                  <Input
                    type="file"
                    onChange={(e) => setPanCard(e.target.files[0])}
                  />
                </Col> */}